import { normalizeHexColor } from '../StoreCheckoutColorPicker/storeCheckoutColorPicker.utils';
import {
  STORE_LOGO_SOURCE,
  STORE_PRIMARY_COLOR_SOURCE,
} from '../constants/storeCheckout.constants';
import type {
  IUpdateStoreRequest,
  StoreLogoSource,
  StorePrimaryColorSource,
} from '@/common/interfaces/store.interface';

export interface IStoreCustomizationBrandingState {
  selectedColor: string;
  primaryColorSource: StorePrimaryColorSource;
  customColors: string[];
  storeLogoFileName: string | null;
  storeLogoSource: StoreLogoSource;
}

export const resolveCustomHexColorForPayload = (customColors: readonly string[]): string | null => {
  const customColor = customColors[0];
  return normalizeHexColor(customColor) ?? null;
};

export const buildStoreCustomizationUpdatePayload = (
  orderId: number,
  branding: IStoreCustomizationBrandingState
): IUpdateStoreRequest => {
  const primaryColor = normalizeHexColor(branding.selectedColor) ?? branding.selectedColor;
  const customHexColor = resolveCustomHexColorForPayload(branding.customColors);
  const hasUploadedLogo = branding.storeLogoSource === STORE_LOGO_SOURCE.UPLOADED;

  return {
    order_id: orderId,
    primary_color: primaryColor,
    primary_color_source: branding.primaryColorSource,
    custom_hex_color: customHexColor,
    store_logo_cms_id: null,
    store_logo_cms_url: null,
    store_logo_file: hasUploadedLogo ? branding.storeLogoFileName : null,
    store_logo_source: branding.storeLogoSource,
  };
};

export const isStorePrimaryColorSource = (value: string): value is StorePrimaryColorSource =>
  value === STORE_PRIMARY_COLOR_SOURCE.PRESET ||
  value === STORE_PRIMARY_COLOR_SOURCE.CUSTOM ||
  value === STORE_PRIMARY_COLOR_SOURCE.EXTRACTED;
